module.exports = __webpack_public_path__ + "img/face25.5b0f98e3.gif";